import type { MediaLibraryState } from './mediaLibraryTypes';
import {
  MEDIA_LIBRARY_FETCH_REQUEST, MEDIA_LIBRARY_FETCH_SUCCESS, MEDIA_LIBRARY_FETCH_FAILURE,
  MEDIA_LIBRARY_ADD, MEDIA_LIBRARY_DELETE,
} from './mediaLibraryTypes';

const initialState: MediaLibraryState = {
  items: [],
  loading: false,
  error: null,
};

let idCounter = 0;

export function mediaLibraryReducer(state = initialState, action: any): MediaLibraryState {
  switch (action.type) {
    case MEDIA_LIBRARY_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case MEDIA_LIBRARY_FETCH_SUCCESS:
      return { ...state, loading: false, items: action.payload };
    case MEDIA_LIBRARY_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case MEDIA_LIBRARY_ADD: {
      idCounter += 1;
      const now = new Date().toISOString();
      const newItem = { id: `ml-${Date.now()}-${idCounter}`, createdAt: now, updatedAt: now, ...action.payload };
      const nextItems = [newItem, ...state.items];
      return { ...state, items: nextItems };
    }
    case MEDIA_LIBRARY_DELETE: {
      const nextItems = state.items.filter((item) => item.id !== action.payload);
      return { ...state, items: nextItems };
    }

    default:
      return state;
  }
}
